import { createContext, useState } from "react";
import { ROUTES } from "../constants/Routes";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({});
  const storedAuth = JSON.parse(localStorage.getItem("rmpAuth")) || {};

  const setAuthHandler = (data) => {
    setAuth(data);
    localStorage.setItem("rmpAuth", JSON.stringify(data));
  };

  const clearAuth = () => {
    localStorage.clear("rmpAuth");
    setAuth("");
  };

  const getAuth = () => {
    return JSON.parse(localStorage.getItem("rmpAuth"));
  };

  const getUser = () => {
    return JSON.parse(localStorage.getItem("rmpAuth"))?.userData;
  };

  return (
    <AuthContext.Provider value={{ getAuth, setAuthHandler, clearAuth, getUser }}>{children}</AuthContext.Provider>
  );
};

export default AuthContext;
